import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 3v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 20v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 12h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 12h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m18.364 5.636-.707.707", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m6.343 17.657-.707.707", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m5.636 5.636.707.707", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17.657 17.657.707.707", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SunMedium";
const SunMedium = memo(themed(Icon));
export {
  SunMedium
};
//# sourceMappingURL=sun-medium.js.map
